// Add a logging utility
const BundleLogger = {
  debug: (message, data) => {
    console.log("Bundle Debug:", message, data || "");
  },
  error: (message, error) => {
    console.error("Bundle Error:", message, error);
  },
  info: (message, data) => {
    console.info("Bundle Info:", message, data || "");
  },
};

// Add these helper functions at the top of the file
const BundleSelectionTracker = {
  debug: true,
  currentSelections: {
    size: null,
    color: null,
  },

  init() {
    BundleLogger.debug("Initializing Bundle Selection Tracker");
    this.trackMainProductSelections();
  },

  trackMainProductSelections() {
    try {
      // Track size selections from main product
      const sizeInputs = document.querySelectorAll(
        'input[type="radio"][name="Size"]'
      );
      sizeInputs.forEach((input) => {
        input.addEventListener("change", () => {
          this.currentSelections.size = input.value;
          BundleLogger.debug("Size selected:", this.currentSelections.size);
        });
      });

      // Track color selections from main product
      const colorInputs = document.querySelectorAll(
        '.filter__checkbox--color input[type="radio"]'
      );
      colorInputs.forEach((input) => {
        input.addEventListener("change", () => {
          this.currentSelections.color = input.value;
          BundleLogger.debug("Color selected:", this.currentSelections.color);
        });
      });

      // Get initial selections if they exist
      const initialSize = Array.from(sizeInputs).find(
        (input) => input.checked
      )?.value;
      const initialColor = Array.from(colorInputs).find(
        (input) => input.checked
      )?.value;

      if (initialSize) this.currentSelections.size = initialSize;
      if (initialColor) this.currentSelections.color = initialColor;

      BundleLogger.debug("Initial selections:", this.currentSelections);
    } catch (error) {
      BundleLogger.error("Error tracking main product selections:", error);
    }
  },

  applySelectionsToBundle() {
    try {
      BundleLogger.debug(
        "Applying selections to bundle:",
        this.currentSelections
      );

      if (this.currentSelections.size) {
        // Handle size selection in bundle
        const bundleSizeButtons = document.querySelectorAll(
          '.mbc-bundle__swatch-element[data-option="option2"]'
        );
        bundleSizeButtons.forEach((button) => {
          if (button.getAttribute("value") === this.currentSelections.size) {
            button.click();
            BundleLogger.debug(
              "Applied size selection to bundle:",
              this.currentSelections.size
            );
          }
        });
      }

      if (this.currentSelections.color) {
        // Handle color selection in bundle
        const bundleColorButtons = document.querySelectorAll(
          '.mbc-bundle__swatch-element[data-option="option1"]'
        );
        bundleColorButtons.forEach((button) => {
          if (button.getAttribute("value") === this.currentSelections.color) {
            button.click();
            BundleLogger.debug(
              "Applied color selection to bundle:",
              this.currentSelections.color
            );
          }
        });
      }
    } catch (error) {
      BundleLogger.error("Error applying selections to bundle:", error);
    }
  },
};

// pack selection
function toggleSelect() {
  try {
    BundleLogger.debug("Attempting to toggle bundle selector");

    const bundleSelector = document.querySelector(".bundle-selector");
    const bundleSelection = document.querySelector(".bundle-selection");

    if (!bundleSelector || !bundleSelection) {
      throw new Error("Required bundle elements not found");
    }

    bundleSelector.classList.toggle("product-detail__size-select-btn-active");
    bundleSelection.classList.toggle("active-show");

    BundleLogger.info("Bundle selector toggled successfully");
  } catch (error) {
    BundleLogger.error("Failed to toggle bundle selector", error);
  }
}
// modal settings
function toggleModal() {
  document.querySelector(".pack-modal").classList.toggle("-closed");
  document.querySelector("body").classList.toggle("stop-scroll");
}
document
  .querySelector(".bundle-selector")
  .addEventListener("click", function () {
    toggleSelect();
  });
document
  .querySelector(".bundle-selection")
  .addEventListener("click", function () {
    toggleSelect();
  });

document.querySelectorAll(".bundle-selection label").forEach((item) => {
  item.addEventListener("click", function () {
    // Remove "active-label" from all custom radio dots
    document.querySelectorAll(".active-label").forEach((element) => {
      element.classList.remove("active-label");
    });

    // Add "active-label" to the custom radio dot within the clicked label
    const customRadioDot = this.querySelector(".custom-radio-dot");
    if (customRadioDot) {
      customRadioDot.classList.add("active-label");

      // Get the selected pack size
      const packAmount = this.getAttribute("data-packamount");

      // Update the "Add to cart" button text based on the selected pack size
      const addToCartButton = document.getElementById(
        "fake-bundle-btn-add-to-cart"
      );
      if (addToCartButton) {
        // get discounted price
        let discountedPrice = this.querySelector(
          ".pack-item-price-discounted"
        ).textContent;
        switch (packAmount) {
          case "3":
            addToCartButton.innerHTML = `ADD 3 Items TO CART &nbsp; ${discountedPrice}`;
            break;
          case "5":
            addToCartButton.innerHTML = `ADD 5 Items TO CART &nbsp; ${discountedPrice}`;
            break;
          case "10":
            addToCartButton.innerHTML = `ADD 10 Items TO CART &nbsp; ${discountedPrice}`;
            break;
          default:
            addToCartButton.textContent = "Add to cart";
        }
      }
    }
  });
});

document
  .querySelector(".pack-modal__close")
  .addEventListener("click", function () {
    toggleModal();
  });
// document.querySelector(".open-modal").addEventListener("click", function () {
//   toggleModal();
// });
document
  .querySelector(".open-modal-additional")
  .addEventListener("click", function () {
    toggleModal();
  });

// mbc bundle customization

function priceConstructor() {
  try {
    BundleLogger.debug("Starting price construction");

    const activeBundle = document.querySelector(".active-bundle");
    if (!activeBundle) {
      BundleLogger.info("No active bundle found, skipping price construction");
      return;
    }

    const priceElement = activeBundle.querySelector(".custom-mbc-price");
    const products = activeBundle.querySelectorAll(".mbc-bundle__item");

    BundleLogger.debug("Found bundle elements", {
      bundleId: activeBundle.dataset.bundle,
      productsCount: products.length,
    });

    if (products.length > 3) {
      activeBundle
        .querySelector(".mbc-bundle__items")
        .classList.add("mbc-bundle__items--long");
    }
    if (priceElement) {
      priceElement.remove();
    }

    let priceConstruction = document.createElement("div"),
      mbcFooter = activeBundle.querySelector(".mbc-bundle__footer");
    let inStockVariant = activeBundle.querySelector(
      ".mbc-bundle__price span:not(.mbc-bundle__compare-price)"
    );
    // Get all the product items
    let productItems = activeBundle.querySelectorAll(".mbc-bundle__item");
    if (inStockVariant) {
      // remove the out of stock price in each product items
      productItems.forEach((item) => {
        let outOfStockElement = item.querySelector(
          ".custom-mbc-price__out-of-stock"
        );
        if (outOfStockElement) {
          outOfStockElement.remove();
        }
      });
      let addToCartBtn = activeBundle.querySelector(
        "button.mbc-bundle__button.mbc-bundle__atc"
      );
      if (
        addToCartBtn &&
        addToCartBtn.innerHTML == "CHOOSE A DIFFERENT COLOUR"
      ) {
        addToCartBtn.innerHTML = "ADD TO CART";
      }

      let scriptElement = document.getElementById(
        "apple-pay-shop-capabilities"
      );
      let currency = this.afterpay_cart_currency;
      if (scriptElement && !currency) {
        let jsonText = scriptElement.textContent;
        let jsonData = JSON.parse(jsonText);
        currency = jsonData.currencyCode;
      }

      let currentPrice = "";
      let comparedPrice = "";

      const currentPriceElement = activeBundle.querySelector(
        ".mbc-bundle__price span:not(.mbc-bundle__compare-price)"
      );

      const comparedPriceElement = activeBundle.querySelector(
        ".mbc-bundle__price .mbc-bundle__compare-price"
      );

      if (currentPriceElement) {
        currentPrice = currentPriceElement.textContent;
      }

      if (comparedPriceElement) {
        comparedPrice = comparedPriceElement.textContent;
      }

      priceConstruction.classList.add("custom-mbc-price");
      priceConstruction.innerHTML = `<span class="custom-mbc-price__text">${comparedPrice}</span> <span class="custom-mbc-price__price">${currentPrice} ${
        !currency ? "" : ` ${currency}`
      }</span>`;
      mbcFooter.before(priceConstruction);
    } else {
      // Iterate through each item
      productItems.forEach((item) => {
        // Check if the item has a price element
        const priceElement = item.querySelector(".mbc-bundle__item-price span");
        if (!priceElement || priceElement.textContent.trim() === "") {
          // If there is no price or the price is empty, set it to "Out of Stock"
          // Find the mbc-bundle__item-info element
          let itemInfo = activeBundle.querySelector(".mbc-bundle__item-info");
          // Create a new div element for "OUT OF STOCK"
          let outOfStockDiv = document.createElement("div");
          outOfStockDiv.className = "mbc-bundle__item-price";
          outOfStockDiv.innerHTML =
            "<span class='custom-mbc-price__out-of-stock'>Out of stock</span>";

          // Append the "OUT OF STOCK" div to the item info div
          itemInfo.appendChild(outOfStockDiv);
        }
      });

      let outOfStockBtn = activeBundle.querySelector(
        "button.mbc-bundle__button.mbc-bundle__atc[disabled]"
      );
      if (outOfStockBtn) {
        outOfStockBtn.innerHTML = "CHOOSE A DIFFERENT COLOUR";
      }
      // footer
      let outOfStock = activeBundle.querySelector(
          ".mbc-bundle__footer .mbc-bundle__out-of-stock"
        ),
        backArrow = document.createElement("div"),
        continueText = "CONTINUE SHOPPING";
      if (outOfStock) {
        outOfStock.innerHTML = "";
      }
      backArrow.classList.add("custom-mbc-footer__arrow");
      backArrow.innerHTML = `
            <svg width="61" height="20" viewBox="0 0 61 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.646442 10.3536C0.451183 10.1583 0.451183 9.84171 0.646442 9.64645L3.82843 6.46447C4.02369 6.2692 4.34027 6.2692 4.53553 6.46447C4.73079 6.65973 4.73079 6.97631 4.53553 7.17157L1.7071 10L4.53553 12.8284C4.73079 13.0237 4.73079 13.3403 4.53553 13.5355C4.34027 13.7308 4.02369 13.7308 3.82843 13.5355L0.646442 10.3536ZM61 10.5H0.999996V9.5H61V10.5Z" fill="black"/>
            </svg>
            ${continueText}
            `;
      backArrow.addEventListener("click", function () {
        toggleModal();
      });
      if (outOfStock) {
        outOfStock.appendChild(backArrow);
      }
      priceConstruction.classList.add("custom-mbc-price");
      priceConstruction.innerHTML = `<span class="custom-mbc-price__text"></span> <span class="custom-mbc-price__price">Out of stock</span>`;
      mbcFooter.before(priceConstruction);
    }

    BundleLogger.info("Price construction completed successfully");
  } catch (error) {
    BundleLogger.error("Failed to construct prices", error);
  }
}

function selectorPriceConstructor() {
  let bundlesData = document.querySelectorAll("[data-bundle]");
  bundlesData.forEach((bundle) => {
    let dataBundle = bundle.getAttribute("data-bundle");
    if (dataBundle === "true") {
      // get single product price
      let singlePrice = document.querySelector(
        ".price-item.price-item--regular"
      ).textContent;
      // remove AUD from price if it exists
      singlePrice = singlePrice.replace("AUD", "");
      const packItemPrice = bundle.querySelector(
        `[data-reset="${dataBundle}"] .pack-item-price`
      );
      if (packItemPrice) {
        packItemPrice.innerHTML = `<span class="pack-item-price-discounted">${singlePrice}</span>`;
      }
    }
    if (
      dataBundle !== "10-pack" &&
      dataBundle !== "5-pack" &&
      dataBundle !== "3-pack"
    )
      return;

    let discountedPrice, fullPrice;

    try {
      discountedPrice = bundle.querySelector(
        `[data-bundle="${dataBundle}"] .mbc-bundle__price span:not(.mbc-bundle__compare-price)`
      )?.textContent;

      fullPrice = bundle.querySelector(
        `[data-bundle="${dataBundle}"] .mbc-bundle__price .mbc-bundle__compare-price`
      )?.textContent;

      // remove the last 3 characters from the price if exists
      if (fullPrice) {
        fullPrice = fullPrice.slice(0, -3);
      }
    } catch (error) {
      // Set fallback prices based on pack type
      switch (dataBundle) {
        case "3-pack":
          discountedPrice = "$67.50";
          fullPrice = "$75.00";
          break;
        case "5-pack":
          discountedPrice = "$106.25";
          fullPrice = "$125.00";
          break;
        case "10-pack":
          discountedPrice = "$200.00";
          fullPrice = "$250.00";
          break;
      }
    }

    if (!discountedPrice || !fullPrice) {
      switch (dataBundle) {
        case "3-pack":
          discountedPrice = "$67.50";
          fullPrice = "$75.00";
          break;
        case "5-pack":
          discountedPrice = "$106.25";
          fullPrice = "$125.00";
          break;
        case "10-pack":
          discountedPrice = "$200.00";
          fullPrice = "$250.00";
          break;
      }
    }
    // Update the .pack-item-price for each bundle with the calculated prices
    let packItemPrice = document.querySelector(
      `[data-packtoggle="${dataBundle}"] .pack-item-price`
    );
    if (packItemPrice) {
      packItemPrice.innerHTML = `<span class="pack-item-price-discounted">${discountedPrice}</span><span class="pack-item-price-full">${fullPrice}</span>`;
    }
  });
}

function customFooterConstructor() {
  let element = document.querySelector(".active-bundle .mbc-bundle__atc");
  if (!element) return;
  let parent = element.parentNode,
    wrapper = document.createElement("div"),
    backArrow = document.createElement("div"),
    continueText = "CONTINUE SHOPPING",
    oldWrapper = document.querySelector(".active-bundle .custom-mbc-footer");

  if (!oldWrapper) {
    backArrow.classList.add("custom-mbc-footer__arrow");
    backArrow.innerHTML = `
            <svg width="61" height="20" viewBox="0 0 61 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.646442 10.3536C0.451183 10.1583 0.451183 9.84171 0.646442 9.64645L3.82843 6.46447C4.02369 6.2692 4.34027 6.2692 4.53553 6.46447C4.73079 6.65973 4.73079 6.97631 4.53553 7.17157L1.7071 10L4.53553 12.8284C4.73079 13.0237 4.73079 13.3403 4.53553 13.5355C4.34027 13.7308 4.02369 13.7308 3.82843 13.5355L0.646442 10.3536ZM61 10.5H0.999996V9.5H61V10.5Z" fill="black"/>
            </svg>
            ${continueText}
            `;
    backArrow.addEventListener("click", function () {
      toggleModal();
    });
    wrapper.classList.add("custom-mbc-footer");
    parent.replaceChild(wrapper, element);
    wrapper.appendChild(element);
    wrapper.append(backArrow);
  }
}

function waitForElm(selector) {
  return new Promise((resolve) => {
    const checkAndResolve = () => {
      const bundlesListExist = document.querySelector(selector);
      const loadingElements = document.querySelectorAll(".mbc-bundle-loading");

      if (bundlesListExist && loadingElements.length === 0) {
        resolve(bundlesListExist);
      } else {
        window.requestAnimationFrame(checkAndResolve);
      }
    };

    window.requestAnimationFrame(checkAndResolve);
  });
}

waitForElm(".mbc-bundles-list").then((elm) => {
  setBundle();
});

function hideBundles() {
  let allBundles = document.querySelectorAll(".mbc-bundle");
  allBundles.forEach((bundle) => {
    bundle.style.display = "none";
    bundle.classList.remove("active-bundle");
  });
}

// function disableQty() {
//   let qtyWrapper = document.querySelector(
//       ".product-bundle-selector__selector__qty"
//     ),
//     btns = qtyWrapper.querySelectorAll("quantity-input button"),
//     inputQty = qtyWrapper.querySelector("input"),
//     qtySelector = qtyWrapper.querySelector("quantity-input"),
//     productVariants = document.querySelector("variant-radios"),
//     customText = document.querySelector(".custom-product-bundle__text");

//   btns.forEach((item) => {
//     item.disabled = true;
//   });
//   inputQty.disabled = true;
//   qtySelector.classList.add("disabled-qty");
//   productVariants.classList.add("disabled-qty");
//   customText.style.display = "block";
// }

function enableQty() {
  let qtyWrapper = document.querySelector(
      ".product-bundle-selector__selector__qty"
    ),
    btns = qtyWrapper.querySelectorAll("quantity-input button"),
    inputQty = qtyWrapper.querySelector("input"),
    qtySelector = qtyWrapper.querySelector("quantity-input"),
    productVariants = document.querySelector("variant-radios"),
    customText = document.querySelector(".custom-product-bundle__text");

  btns.forEach((item) => {
    item.disabled = false;
  });
  inputQty.disabled = false;
  qtySelector.classList.remove("disabled-qty");
  productVariants.classList.remove("disabled-qty");
  customText.style.display = "none";
}

// simple insert after jquery like
function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

// set up size btns as dropdown
function setUpSelectors() {
  let sizeElement = document.querySelector(
    ".product-detail__size-select-btn.select_btn:first-child"
  );
  let colorElement =
    document.querySelector('input[type="radio"][name="Color"]:checked') ||
    document.querySelector('input[type="radio"][name="Colour"]:checked');

  let currentSize;
  let currentColor;
  if (sizeElement) {
    // if there is attribute of data-size, get the value and set it as current size
    const dataSize = sizeElement.getAttribute("data-size");
    if (dataSize) {
      currentSize = sizeElement.getAttribute("data-size");
    } else {
      currentSize = sizeElement.textContent.trim();
    }
  }
  if (colorElement) {
    currentColor = colorElement.value;
  }
  setTimeout(() => {
    let btnContainers = document.querySelectorAll(
      ".mbc-bundle__swatch-type-button"
    );
    console.log("btnContainers ", btnContainers);

    // Add a small delay before processing the containers
    btnContainers.forEach((item) => {
      let btnList = item.querySelector(".mbc-bundle__swatch-element-list"),
        btnSelector = document.createElement("div"),
        place = item.querySelector(".mbc-bundle__swatch-header"),
        body = document.querySelector("body");
      if (place.innerHTML.includes("Size")) {
        console.log("currentSize ", currentSize);
        console.log("btnList ", btnList);
        let sizeOption = btnList.querySelector(
          `[data-option="option2"][value="${currentSize}"]`
        );
        console.log("sizeOption ", sizeOption);
        if (sizeOption) {
          sizeOption.click();
        }
        console.log("btnSelector ", btnSelector);
        btnSelector.classList.add("custom-select-trg");
        btnSelector.innerHTML = `
                  <div class="custom-select-trg__inner">
                      ${currentSize}
                  </div>
              `;
        btnList.classList.add("custom-select-drpdwn");
        btnList.querySelectorAll("label").forEach((label) => {
          label.addEventListener("click", function () {
            btnSelector.querySelector(".custom-select-trg__inner").textContent =
              this.textContent;
          });
        });
        insertAfter(btnSelector, place);
        btnSelector.addEventListener("click", function () {
          document
            .querySelectorAll(".custom-select-trg")
            .forEach((selector) => {
              if (selector != this) {
                selector.classList.remove("active-select");
              }
            });
          document
            .querySelectorAll(".custom-select-drpdwn")
            .forEach((selector) => {
              if (selector != btnList) {
                selector.classList.remove("active-list");
                body.classList.remove("watch-click");
              }
            });
          if (this.classList.contains("active-select")) {
            this.classList.remove("active-select");
            body.classList.remove("watch-click");
          } else {
            this.classList.add("active-select");
            body.classList.add("watch-click");
            document
              .querySelector(".watch-click")
              .addEventListener("click", function (e) {
                if (
                  e.target.matches(".custom-select-trg") ||
                  !e.target.closest(".custom-select-trg__inner")
                ) {
                  closeDropdowns();
                }
              });
          }
          if (btnList.classList.contains("active-list")) {
            btnList.classList.remove("active-list");
          } else {
            btnList.classList.add("active-list");
          }
        });
      }

      if (place.innerHTML == "Color:" || place.innerHTML == "Colour:") {
        let colorOption = btnList.querySelector(
          `[data-option="option1"][value="${currentColor}"]`
        );
        if (colorOption) {
          colorOption.click();
        }
      }
    });
  }, 300); // Wait 300ms before processing
}

function matchesOptionType(headerText, optionType) {
  try {
    // Normalize strings to lowercase for comparison
    const normalizedHeader = headerText.toLowerCase().trim();
    const normalizedOption = optionType.toLowerCase().trim();

    // Define valid variations for each option type
    const validMatches = {
      size: ["size"],
      color: ["color", "colour"],
    };

    // Check if it's a size comparison
    if (validMatches.size.some((term) => normalizedHeader.includes(term))) {
      return validMatches.size.some((term) => normalizedOption.includes(term));
    }

    // Check if it's a color comparison
    if (validMatches.color.some((term) => normalizedHeader.includes(term))) {
      return validMatches.color.some((term) => normalizedOption.includes(term));
    }

    BundleLogger.debug("Option type match check:", {
      headerText: normalizedHeader,
      optionType: normalizedOption,
      isMatch: false,
    });

    return false;
  } catch (error) {
    BundleLogger.error("Error in matchesOptionType:", error);
    return false;
  }
}

function updateOptions(optionType, currentValue) {
  const optionContainers = document.querySelectorAll(
    ".mbc-bundle__swatch-type-button"
  );
  optionContainers.forEach((item) => {
    const btnList = item.querySelector(".mbc-bundle__swatch-element-list");
    const place = item.querySelector(".mbc-bundle__swatch-header");
    if (matchesOptionType(place.innerHTML, optionType)) {
      const optionSelector = `[data-option="option${
        optionType === "Size:" ? 2 : 1
      }"][value="${currentValue}"]`;
      const option = btnList.querySelector(optionSelector);
      if (option) {
        option.click();
        if (optionType.trim() === "Size:") {
          const innerSizeDiv = item.querySelector(".custom-select-trg__inner");
          if (innerSizeDiv) {
            innerSizeDiv.textContent = currentValue;
          }
        }
      }
    }
  });
}

// Main orchestrator function
function setListeners() {
  BundleLogger.debug("Initializing bundle listeners");
  setupBundleSwatchListeners();
  setupSizeSelectionListeners();
  setupColorSelectionListeners();
}

// Handle bundle swatch elements
function setupBundleSwatchListeners() {
  try {
    const labels = document.querySelectorAll(".mbc-bundle__swatch-element");
    BundleLogger.debug("Setting up bundle swatch listeners", {
      count: labels.length,
    });

    labels.forEach((label, index) => {
      label.addEventListener("click", () => {
        BundleLogger.debug(`Bundle swatch ${index} clicked`);
        handleBundleSwatchClick();
      });
    });
  } catch (error) {
    BundleLogger.error("Error setting up bundle swatch listeners:", error);
  }
}

function handleBundleSwatchClick() {
  setTimeout(() => {
    try {
      priceConstructor();
      customFooterConstructor();
      BundleLogger.debug(
        "Bundle swatch click handled - price and footer updated"
      );
    } catch (error) {
      BundleLogger.error("Error handling bundle swatch click:", error);
    }
  }, 500);
}

// Handle size selection
function setupSizeSelectionListeners() {
  try {
    const sizeLabels = document.querySelectorAll(
      ".product-form__input-wrapper.product-detail__size-nav.size_nav:not(.bundle-selection)"
    );
    BundleLogger.debug("Setting up size selection listeners", {
      count: sizeLabels.length,
    });

    sizeLabels.forEach((label, index) => {
      label.addEventListener("click", () => {
        BundleLogger.debug(`Size label ${index} clicked`);
        handleSizeSelection();
      });
    });
  } catch (error) {
    BundleLogger.error("Error setting up size selection listeners:", error);
  }
}

function handleSizeSelection() {
  try {
    const sizeElement = document.querySelector(
      ".product-detail__size-select-btn.select_btn:first-child"
    );

    if (!sizeElement) {
      BundleLogger.debug("Size element not found");
      return;
    }

    const currentSize = sizeElement.textContent.trim();
    BundleLogger.debug("Size selected", { size: currentSize });

    updateOptions("Size:", currentSize);
  } catch (error) {
    BundleLogger.error("Error handling size selection:", error);
  }
}

// Handle color selection
function setupColorSelectionListeners() {
  try {
    const colorOptions = document.querySelectorAll(
      ".filter__options--colors .filter__checkbox--color"
    );
    BundleLogger.debug("Setting up color selection listeners", {
      count: colorOptions.length,
    });

    colorOptions.forEach((colorOption, index) => {
      const label = colorOption.querySelector("label");
      const input = colorOption.querySelector('input[type="radio"]');

      if (!label || !input) {
        BundleLogger.debug(`Color option ${index} missing required elements`);
        return;
      }

      label.addEventListener("click", () => {
        handleColorSelection(input);
      });
    });
  } catch (error) {
    BundleLogger.error("Error setting up color selection listeners:", error);
  }
}

function handleColorSelection(input) {
  try {
    const selectedColor = input.value;
    BundleLogger.debug("Color selected", { color: selectedColor });

    updateOptions("Color:", selectedColor);
  } catch (error) {
    BundleLogger.error("Error handling color selection:", error);
  }
}

function setBundle() {
  try {
    BundleLogger.debug("Initializing bundle setup");

    // Initialize the selection tracker
    BundleSelectionTracker.init();

    const allBundles = document.querySelectorAll(".mbc-bundle");
    const allSelectors = document.querySelectorAll("[data-packtoggle]");
    const singleBtn = document.querySelector("[data-reset]");
    const fakeBtns = document.querySelector(".fake-form-btns");
    const formBtns = document.querySelector(".product-form__buttons");

    // Get initial selections
    const initialSelections = {
      size: document.querySelector('input[type="radio"][name="Size"]:checked')
        ?.value,
      color: document.querySelector(
        '.filter__checkbox--color input[type="radio"]:checked'
      )?.value,
    };

    console.log("Initial selections found:", initialSelections);

    // Apply initial selections if they exist
    if (initialSelections.size || initialSelections.color) {
      setTimeout(() => {
        try {
          if (initialSelections.size) {
            updateOptions("Size:", initialSelections.size);
            BundleLogger.debug(
              "Applied initial size selection:",
              initialSelections.size
            );
          }
          if (initialSelections.color) {
            updateOptions("Color:", initialSelections.color);
            BundleLogger.debug(
              "Applied initial color selection:",
              initialSelections.color
            );
          }
        } catch (error) {
          BundleLogger.error("Error applying initial selections:", error);
        }
      }, 500); // Give the bundle time to initialize
    }

    if (!fakeBtns || !formBtns) {
      throw new Error("Required button elements not found");
    }

    BundleLogger.debug("Found bundle elements", {
      bundlesCount: allBundles.length,
      selectorsCount: allSelectors.length,
    });

    // Set up bundle data attributes
    allBundles.forEach((bundle, index) => {
      try {
        const titleElement = bundle.querySelector(".mbc-bundles-list__title");
        if (!titleElement) {
          throw new Error(`Bundle ${index} missing title element`);
        }

        const bundleName = titleElement.textContent;
        bundle.dataset.bundle = bundleName.replace(" ", "-").toLowerCase();

        BundleLogger.debug(`Bundle ${index} configured`, {
          name: bundleName,
          dataAttribute: bundle.dataset.bundle,
        });
      } catch (error) {
        BundleLogger.error(`Failed to configure bundle ${index}`, error);
      }
    });

    // Initialize price constructor
    try {
      selectorPriceConstructor();
    } catch (error) {
      BundleLogger.error("Failed to initialize price constructor", error);
    }

    // Set up event listeners
    if (singleBtn) {
      singleBtn.addEventListener("click", () => {
        try {
          BundleLogger.debug("Single button clicked");
          hideBundles();
          fakeBtns.style.display = "none";
          formBtns.style.display = "block";
        } catch (error) {
          BundleLogger.error("Error handling single button click", error);
        }
      });
    }

    // Set up selector listeners
    allSelectors.forEach((item, index) => {
      item.addEventListener("click", () => {
        try {
          BundleLogger.debug(`Selector ${index} clicked`, {
            packToggle: item.dataset.packtoggle,
            packAmount: item.dataset.packamount,
          });

          const currentIndex = item.dataset.packtoggle;
          const packText = currentIndex.toUpperCase().replace("-", " "); // e.g., "3 PACK"

          // Wait for bundles to be fully rendered
          const waitForBundle = () => {
            return new Promise((resolve) => {
              const checkBundle = () => {
                const bundles = document.querySelectorAll(".mbc-bundle");
                const bundlesList = document.querySelector(".mbc-bundles-list");

                if (
                  bundles.length > 0 &&
                  bundlesList &&
                  !bundlesList.querySelector(".mbc-bundle-loading")
                ) {
                  BundleLogger.debug("Bundles found and loaded", {
                    count: bundles.length,
                  });
                  resolve(bundles);
                } else {
                  BundleLogger.debug("Waiting for bundles to load...");
                  setTimeout(checkBundle, 100);
                }
              };
              checkBundle();
            });
          };

          // Use the promise to handle bundle selection
          waitForBundle().then((bundles) => {
            let neededBundle = null;
            bundles.forEach((bundle) => {
              const titleElement = bundle.querySelector(
                ".mbc-bundles-list__title"
              );
              if (
                titleElement &&
                titleElement.textContent.trim() === packText
              ) {
                neededBundle = bundle;
              }
            });

            if (!neededBundle) {
              BundleLogger.error(`Bundle not found for pack type: ${packText}`);
              return;
            }

            hideBundles();

            // Force a browser reflow before showing the new bundle
            void neededBundle.offsetHeight;

            neededBundle.style.display = "block";
            neededBundle.classList.add("active-bundle");

            // Add a small delay before running constructors
            setTimeout(() => {
              BundleLogger.debug("Bundle state check", {
                isVisible: neededBundle.style.display === "block",
                hasActiveClass:
                  neededBundle.classList.contains("active-bundle"),
                element: neededBundle,
              });

              fakeBtns.style.display = "block";
              formBtns.style.display = "none";

              const packNumElement = document.querySelector(".packnum");
              if (packNumElement) {
                packNumElement.innerHTML = item.dataset.packamount;
              }

              priceConstructor();
              customFooterConstructor();

              BundleLogger.info("Bundle selection completed successfully");
            }, 100);
          });
        } catch (error) {
          BundleLogger.error("Error handling selector click", error);
        }
      });
    });

    // Initialize UI setup
    try {
      function bundleCallback() {
        toggleModal();
        document.querySelector("a#cart-icon-bubble").click();
      }

      document.addEventListener(
        "MAKEBECOOL_BUNDLES.updateCart",
        bundleCallback
      );

      document
        .querySelector(".custom-product-bundle")
        .classList.remove("custom-product-bundle--hidden");
      setUpSelectors();
      setListeners();
      BundleLogger.info("Bundle setup completed successfully");
    } catch (error) {
      BundleLogger.error("Error during final bundle setup", error);
    }
  } catch (error) {
    BundleLogger.error("Fatal error during bundle initialization", error);
  }
}
function closeDropdowns() {
  document.querySelectorAll(".custom-select-trg").forEach((selector) => {
    selector.classList.remove("active-select");
  });
  document.querySelectorAll(".custom-select-drpdwn").forEach((selector) => {
    selector.classList.remove("active-list");
  });
}
